import Admin from './AdminContainer';

export default Admin;
